//v2.3.6 - custom theming built for an app suite called "p"
// for the font weights, need to replace this style sheet to public index.html: https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap
import {createTheme} from '@mui/material/styles'

// start tokens
// start color tokens
// start system tokens
const systemColor = {
  // start gray
  pWhite: '#ffffff',
  pGray50: '#fffdfb',
  pGray75: '#f5f5f5',
  pGray100: '#f2f2f2',
  pGray200: '#d0d0ce',
  pGray300: '#bbbcbc',
  pGray400: '#a7a8aa',
  pGray500: '#97999b',
  pGray600: '#75787b',
  pGray700: '#63666a',
  pGray800: '#53565a',
  pGray900: '#292929',
  pBlack: '#000000',

  // end gray

  // start red
  pRed50: '#fbe9e8',
  pRed100: '#f7d4d1',
  pRed200: '#f0a9a4',
  pRed300: '#e56960',
  pRed400: '#dd3e32',
  pRed500: '#da291c',
  pRed600: '#c42419',
  pRed700: '#ae2016',
  pRed800: '#981c13',
  pRed900: '#57100b',
  // end red

  // start orange
  pOrange50: '#fff7e1',
  pOrange100: '#fef1cb',
  pOrange200: '#fde097',
  pOrange300: '#f9c863',
  pOrange400: '#f4b03d',
  pOrange500: '#ed8b00',
  pOrange600: '#cb6e00',
  pOrange700: '#aa5500',
  pOrange800: '#893f00',
  pOrange900: '#712f00',
  // end orange

  // start yellow
  pYellow50: '#fffae5',
  pYellow100: '#fff5cc',
  pYellow200: '#ffeb99',
  pYellow300: '#ffe166',
  pYellow400: '#ffd732',
  pYellow500: '#ffcd00',
  pYellow600: '#deb200',
  pYellow700: '#ab8900',
  pYellow800: '#665200',
  pYellow900: '#4c3d00',
  // end yellow

  // start yellow green
  pYellowGreen50: '#fffff4',
  pYellowGreen100: '#fdfdea',
  pYellowGreen200: '#fbfcd5',
  pYellowGreen300: '#f6f6be',
  pYellowGreen400: '#eeeeaa',
  pYellowGreen500: '#e3e48d',
  pYellowGreen600: '#bbc99b',
  pYellowGreen700: '#a2a447',
  pYellowGreen800: '#82842c',
  pYellowGreen900: '#6c6d1b',
  // end yellow green

  // start green
  pGreen50: '#faffe6',
  pGreen100: '#f3fbd3',
  pGreen200: '#e4f8a8',
  pGreen300: '#caea79',
  pGreen400: '#add655',
  pGreen500: '#86bc25',
  pGreen600: '#6ca11b',
  pGreen700: '#26890d',
  pGreen800: '#046a38',
  pGreen900: '#2c5234',
  // end green

  // start greenvivid
  pGreenVivid50: '#e7ffe8',
  pGreenVivid100: '#c7f9ca',
  pGreenVivid200: '#92f4a0',
  pGreenVivid300: '#59e07a',
  pGreenVivid400: '#30c262',
  pGreenVivid500: '#009a44',
  pGreenVivid600: '#008447',
  pGreenVivid700: '#006e47',
  pGreenVivid800: '#005942',
  pGreenVivid900: '#00493e',
  // end greenvivid

  // start blue
  pBlue50: '#e5f5fb',
  pBlue100: '#cc3cf8',
  pBlue200: '#a0dcff',
  pBlue300: '#62b5e5',
  pBlue400: '#00a3e0',
  pBlue500: '#007cb0',
  pBlue600: '#0076a8',
  pBlue700: '#005587',
  pBlue800: '#003b5e',
  pBlue900: '#041e42',
  // end blue

  // start teal
  pTeal50: '#f0f8f7',
  pTeal100: '#ddefe8',
  pTeal200: '#c5e6e1',
  pTeal300: '#9dd4cf',
  pTeal400: '#6fc2b4',
  pTeal500: '#00abab',
  pTeal600: '#0097a9',
  pTeal700: '#007680',
  pTeal800: '#006770',
  pTeal900: '#004f59',
  // end teal

  // start pink
  pPink50: '#fff5f9',
  pPink100: '#ffecec',
  pPink200: '#ffd9dc',
  pPink300: '#ffc6d0',
  pPink400: '#ffb7cc',
  pPink500: '#ffa0c5',
  pPink600: '#db74a6',
  pPink700: '#b7508d',
  pPink800: '#933375',
  pPink900: '#7a1e66',
  // end pink

  // start purple
  pPurple50: '#f5f4fd',
  pPurple100: '#eceafc',
  pPurple200: '#dad5fa',
  pPurple300: '#bfb6f7',
  pPurple400: '#ada1f5',
  pPurple500: '#a497f4',
  pPurple600: '#8d82d1',
  pPurple700: '#7269aa',
  pPurple800: '#625a92',
  pPurple900: '#524b7a',
  // end purple

  //start brown
  pBrownA100: '#88695E',
  // end brown

  //missingGeoIds color
  pYellow40: '#FFFAE7',
  pYellow55: '#FFF9DE'
}
// end system color tokens

// theming tokens: map semantic names to your app using system color tokens from above
// we are mapping the system colors from the p suite to the hp app. if we have an additional app, we can map the same p system colors from above with new design color abbreviations below. in future, we can map inverse using system colors for dark modes (hpPrimaryInverse, hpPrimaryLightInverse etc...)
const themeColor = {
  // start neutrals
  hpBlack: systemColor.pGray900,
  hpWhite: systemColor.pWhite,
  // end neutrals
  // start primary
  hpPrimaryLightest: systemColor.pBlue50,
  hpPrimaryLighter: systemColor.pBlue200,
  hpPrimaryLight: systemColor.pBlue300,
  hpPrimaryMain: systemColor.pBlue400,
  hpPrimary: systemColor.pBlue500,
  hpPrimaryDark: systemColor.pBlue700,
  hpPrimaryDarker: systemColor.pBlue800,
  hpPrimaryDarkest: systemColor.pBlue900,
  //end primary
  //start base
  hpBaseLightest: systemColor.pGray50,
  hpBaseLighter: systemColor.pGray100,
  hpBaseLightMedium: systemColor.pGray75,
  hpBaseLight: systemColor.pGray300,
  hpBase: systemColor.pGray500,
  hpBaseDark: systemColor.pGray700,
  hpBaseDarker: systemColor.pGray800,
  hpBaseDarkest: systemColor.pGray900,
  // end base
  // start accent
  hpAccentBlack: systemColor.pBlack,
  hpAccentTeal: systemColor.pTeal600,
  hpAccentAqua: systemColor.pTeal300,
  hpAccentAquaGreen: systemColor.pTeal400,
  hpAccentPersianGreen: systemColor.pTeal500,
  hpAccentOrange: systemColor.pOrange500,
  hpAccentDarkOrange: systemColor.pOrange600,
  hpAccentGreenLight: systemColor.pGreen400,
  hpAccentGreen: systemColor.pGreen500,
  hpAccentGreenDark: systemColor.pGreen600,
  hpAccentBlue: systemColor.pBlue300,
  hpAccentPurple: systemColor.pPurple500,
  hpAccentLightPink: systemColor.pPink300,
  hpAccentLighterPink: systemColor.pPink100,
  hpAccentPink: systemColor.pPink500,
  hpAccentDarkPink: systemColor.pPink600,
  hpAccentDarkerestPink: systemColor.pPink800,
  hpAccentVioletPink: systemColor.pPink900,
  hpAccentDarkerPink: systemColor.pPink700,
  hpAccentGreenVividLight: systemColor.pGreenVivid400,
  hpAccentGreenVivid: systemColor.pGreenVivid500,
  hpAccentYellowLightest: systemColor.pYellow50,
  hpAccentYellow: systemColor.pYellow500,
  hpAccentMustardYellow: systemColor.pYellow600,
  hpAccentRedLight: systemColor.pRed300,
  hpAccentRed: systemColor.pRed500,
  hpAccentLightYellow: systemColor.pYellowGreen300,
  hpAccentYellowGreen: systemColor.pYellowGreen500,
  hpAccentYellowGreenDark: systemColor.pYellowGreen600,
  hpAccentYellowDarkMustard: systemColor.pYellow700,
  hpErrorRed: systemColor.pRed300,
  hpErrorRedLightest: systemColor.pRed50,
  hpErrorRedHover: systemColor.pRed400,

  // end accent
  hpPupleDark: systemColor.pPurple600,
  hpGreenVividDark: systemColor.pGreenVivid600,
  hpYellowDark: systemColor.pYellow600,
  hpYellowDarker: systemColor.pYellow800,
  hpRedDark: systemColor.pRed600,
  hpOrangeDark: systemColor.pOrange600,
  hpOrangeDarker: systemColor.pOrange700,
  hpGrayDark: systemColor.pGray600,
  hpBrownLighter: systemColor.pBrownA100,
  hpPurpleLightest: systemColor.pPurple50,

  hpYellowLightest: systemColor.pYellow40,
  hpYellowLight: systemColor.pYellow55
}
// end color tokens

// start typography tokens
// start font family
const systemTypographyFamily = {
  Sans: '"Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
}
// end font family

// start weight
const systemTypographyWeight = {
  Light: 300,
  Regular: 400,
  Medium: 500,
  Semibold: 600,
  Bold: 700,
  Extrabold: 800
}
// end weight

// start line height
const systemTypographyLineHeight = {
  // learn more here: https://developer.mozilla.org/en-US/docs/Web/CSS/line-height (we are using unitless as it is standard)
  1: 1, // 100% of the font size eg. 16px = 16px line height
  2: 1.15, // 115% of the font size eg. 1.15*16px= 18.4px (just for example only)
  3: 1.35, // 135%
  4: 1.5, // 150%
  5: 1.62, // 162%
  6: 1.75, // 175%
  7: 2.15, // 215%
  8: 2.35, // 235%
  9: 2.5, // 250%
  10: 2.62 // 262%
}
// end line height
// start system typography size
const systemTypographySize = {
  // based on a 16px base size
  Micro: '0.625rem', // 10px
  1: '0.75rem', // 12px
  2: '0.8125rem', // 13px
  3: '0.875rem', // 14px
  4: '0.9375rem', // 15px
  5: '1rem', // 16px
  6: '1.0625rem', // 17px
  7: '1.125rem', // 18px
  8: '1.25rem', // 20px
  9: '1.375rem', // 22px
  10: '1.5rem', // 24px
  11: '1.75rem', // 28px
  12: '2rem', // 32px
  13: '2.25rem', // 36px
  14: '2.5rem', // 40px
  15: '3rem', // 48px
  16: '3.5rem', // 56px
  17: '4rem', // 64px
  18: '5rem', // 80px
  19: '6.25rem', // 100px
  20: '7.5rem', // 120px
  21: '8.75rem' // 140px
}
// end system typography size
// start theme typography size
const themeTypographySize = {
  // based on a 16px base size
  XXL: systemTypographySize[15], // 48px
  XL: systemTypographySize[14], // 40px
  L: systemTypographySize[13], // 36px
  M: systemTypographySize[12], // 32px
  S: systemTypographySize[10], // 24px
  XS: systemTypographySize[5], // 16px
  XXS: systemTypographySize[3], // 14px
  XXXS: systemTypographySize[1], // 12px
  XXXM: systemTypographySize[2] // 13px
}
// end theme typography size
// end typography tokens

// start spacing unit tokens
const systemSpacingUnits = {
  0.5: '4px',
  1: '8px',
  2: '16px',
  2.5: '20px',
  3: '24px',
  4: '32px',
  5: '40px',
  6: '48px',
  7: '56px',
  8: '64px',
  9: '72px',
  10: '80px',
  15: '120px',
  card: '160px',
  cardLg: '240px',
  mobile: '320px',
  mobileLarge: '600px', // matches mui 'sm'
  tablet: '960px', // matches mui custom 'md'
  tabletLarge: '1280px', // matches mui custom 'lg'
  desktop: '1628', // matches mui custom 'xl'
  desktopLarge: '1920px' // matches mui custom 'xxl'
}
// end spacing unit tokens

// create the mui theme using the design tokens
const pTheme = createTheme({
  palette: {
    heatmapColor: {
      pink600: themeColor.hpAccentDarkPink,
      pinkDark: themeColor.hpAccentPink,
      pinkMed: themeColor.hpAccentLightPink,
      pinkLight: themeColor.hpAccentLighterPink,
      default: 'rgba(255, 255, 255, 0)',
      greenLight: '#8ACA6D',
      greenMedium: '#63B93C',
      greenDark: '#3CA70B',
      purpleLight: themeColor.hpAccentDarkPink,
      purpleMedium: themeColor.hpAccentDarkerestPink,
      purpleDark: themeColor.hpAccentVioletPink
    },
    primary: {
      main: themeColor.hpPrimary,
      light: themeColor.hpPrimaryLight,
      dark: themeColor.hpPrimaryDark,
      contrastText: themeColor.hpWhite
    },
    secondary: {
      main: systemColor.pPurple700,
      light: systemColor.pPurple100,
      dark: systemColor.pPurple900,
      contrastText: themeColor.hpWhite
    },
    error: {
      main: systemColor.pRed500,
      light: systemColor.pRed50,
      dark: systemColor.pRed800,
      contrastText: themeColor.hpWhite
    },
    warning: {
      main: systemColor.pOrange800,
      light: systemColor.pOrange50,
      dark: systemColor.pOrange900,
      contrastText: themeColor.hpWhite
    },
    info: {
      main: systemColor.pTeal700,
      light: systemColor.pTeal50,
      dark: systemColor.pTeal800,
      contrastText: themeColor.hpWhite
    },
    success: {
      main: systemColor.pGreenVivid600,
      light: systemColor.pGreenVivid50,
      dark: systemColor.pGreenVivid800,
      contrastText: themeColor.hpWhite
    },
    grey: {
      50: systemColor.pGray50,
      100: systemColor.pGray100,
      200: systemColor.pGray200,
      300: systemColor.pGray300,
      400: systemColor.pGray400,
      500: systemColor.pGray500,
      600: systemColor.pGray600,
      700: systemColor.pGray700,
      800: systemColor.pGray800,
      900: systemColor.pGray900
    },
    graph: {
      icon: systemColor.pGray200
    },
    personaColor: {
      persona1: ['#00A3E0', '#26B1E5', '#73CCEE'], //Traditional Individualists
      persona2: ['#00ABAB', '#26B8B8', '#26B8B8'], //Small-Town Strivers
      persona3: ['#A497F4', '#B2A7F6', '#B2A7F6'], //Stable Status Quo
      persona4: ['#DB74A6', '#E089B3', '#E089B3'], //Working-Class Commuters
      persona5: ['#E7726A', '#EB8780', '#F2B1AD'], //High Hopes
      persona6: ['#ed8b00', '#F09C26', '#F5BF73'], //Independent Neighbors
      persona7: ['#CCA400', '#D4B226', '#E3CD73'], //American Mosaic
      persona8: ['#43B02A', '#5FBC4A', '#5FBC4A'], //Urban Anchors
      persona9: ['#0076A8', '#268BB5', '#268BB5'], //Middle of the Road
      persona10: ['#0D8390', '#3196A1', '#7ABBC2'], //Right on Main Street
      persona11: ['#7167B1', '#867EBD', '#B1ABD4'], //Established Empty-Nesters
      persona12: ['#CC3980', '#D45693', '#E392B9'], //Metropolitan Comforts
      persona13: ['#da291c', '#DF493E', '#EB8982'], //Established Residents
      persona14: ['#B86C00', '#C38226', '#D8AE73'], //Strollers and Starter Homes
      persona15: ['#8F7300', '#A08826', '#C1B273'] //Educated Cosmopolitans
    },
    // start apply custom theme colors - if you want to reference the colors directly in a component via sx, you need to run them through the MUI theme then reference them in your component
    personaTooltipHeader: systemColor.pPink700,
    hpBlack: themeColor.hpBlack,
    hpWhite: themeColor.hpWhite,
    hpPrimaryLightest: themeColor.hpPrimaryLightest,
    hpPrimaryLighter: themeColor.hpPrimaryLighter,
    hpPrimaryLight: themeColor.hpPrimaryLight,
    hpPrimaryMain: themeColor.hpPrimaryMain,
    hpPrimary: themeColor.hpPrimary,
    hpPrimaryDark: themeColor.hpPrimaryDark,
    hpPrimaryDarker: themeColor.hpPrimaryDarker,
    hpPrimaryDarkest: themeColor.hpPrimaryDarkest,
    hpBaseLightest: themeColor.hpBaseLightest,
    hpBaseLighter: themeColor.hpBaseLighter,
    hpBaseLight: themeColor.hpBaseLight,
    hpBase: themeColor.hpBase,
    hpBaseDark: themeColor.hpBaseDark,
    hpBaseDarker: themeColor.hpBaseDarker,
    hpBaseDarkest: themeColor.hpBaseDarkest,
    hpAccentBlack: themeColor.hpAccentBlack,
    hpAccentTeal: themeColor.hpAccentTeal,
    hpAccentAqua: themeColor.hpAccentAqua,
    hpAccentAquaGreen: themeColor.hpAccentAquaGreen,
    hpAccentPersianGreen: themeColor.hpAccentPersianGreen,
    hpAccentOrange: themeColor.hpAccentOrange,
    hpAccentDarkOrange: themeColor.hpAccentDarkOrange,
    hpAccentGreenLight: themeColor.hpAccentGreenLight,
    hpAccentGreen: themeColor.hpAccentGreen,
    hpAccentGreenDark: themeColor.hpAccentGreenDark,
    hpAccentBlue: themeColor.hpAccentBlue,
    hpAccentPurple: themeColor.hpAccentPurple,
    hpAccentLightPink: themeColor.hpAccentLightPink,
    hpAccentLighterPink: themeColor.hpAccentLighterPink,
    hpAccentPink: themeColor.hpAccentPink,
    hpAccentDarkPink: themeColor.hpAccentDarkPink,
    hpAccentDarkerestPink: themeColor.hpAccentDarkerestPink,
    hpAccentVioletPink: themeColor.hpAccentVioletPink,
    hpAccentDarkerPink: themeColor.hpAccentDarkerPink,
    hpAccentGreenVividLight: themeColor.hpAccentGreenVividLight,
    hpAccentGreenVivid: themeColor.hpAccentGreenVivid,
    hpAccentYellowLightest: themeColor.hpAccentYellowLightest,
    hpAccentYellow: themeColor.hpAccentYellow,
    hpAccentMustardYellow: themeColor.hpAccentMustardYellow,
    hpAccentRed: themeColor.hpAccentRed,
    hpAccentRedLight: themeColor.hpAccentRedLight,
    hpAccentLightYellow: themeColor.hpAccentLightYellow,
    hpAccentYellowGreen: themeColor.hpAccentYellowGreen,
    hpAccentYellowGreenDark: themeColor.hpAccentYellowGreenDark,
    hpAccentYellowDarkMustard: themeColor.hpAccentYellowDarkMustard,
    hpErrorRed: themeColor.hpErrorRed,
    hpErrorRedLightest: themeColor.hpErrorRedLightest,
    hpErrorRedHover: themeColor.hpErrorRedHover,

    hpPupleDark: themeColor.hpPupleDark,
    hpGreenVividDark: themeColor.hpGreenVividDark,
    hpYellowDark: themeColor.hpYellowDark,
    hpYellowDarker: themeColor.hpYellowDarker,
    hpRedDark: themeColor.hpRedDark,
    hpOrangeDark: themeColor.hpOrangeDark,
    hpOrangeDarker: themeColor.hpOrangeDarker,
    hpGrayDark: themeColor.hpGrayDark,
    hpBrownLighter: themeColor.hpBrownLighter,
    hpPurpleLightest: themeColor.hpPurpleLightest,
    // end apply custom theme colors - if you want to reference the colors directly in the project, you need to run them through the MUI theme then reference them in your component

    divider: themeColor.hpBaseLight,
    background: {
      default: themeColor.hpBaseLighter,
      paper: themeColor.hpWhite
    },
    text: {
      primary: systemColor.pGray900,
      secondary: systemColor.pGray700,
      disabled: systemColor.pGray400,
      hint: systemColor.pGray300
    }
  },
  typography: {
    // 'Open Sans' as the primary font, followed by the system UI font stack
    fontFamily: systemTypographyFamily.Sans,
    fontSize: 16, // base font size
    fontWeightLight: systemTypographyWeight.Light,
    fontWeightRegular: systemTypographyWeight.Regular,
    fontWeightMedium: systemTypographyWeight.Medium,
    fontWeightSemibold: systemTypographyWeight.Semibold,
    fontWeightBold: systemTypographyWeight.Bold,
    fontWeightExtrabold: systemTypographyWeight.Extrabold,
    h1: {
      fontSize: themeTypographySize.XXL, // 48px
      fontWeight: systemTypographyWeight.Bold,
      lineHeight: systemTypographyLineHeight[2]
      // [`@media (max-width: ${systemSpacingUnits.tabletLarge})`]: {
      //   fontSize: systemTypographySize[14] // 40px // adjusted size for screens smaller than 1280px
      // },
      // [`@media (max-width: ${systemSpacingUnits.tablet})`]: {
      //   fontSize: systemTypographySize[13] // 36px // adjusted size for screens smaller than 960px
      // },
      // [`@media (max-width: ${systemSpacingUnits.mobileLarge})`]: {
      //   fontSize: systemTypographySize[12] // 32px // adjusted size for screens smaller than 600px
      // }
    },
    h2: {
      fontSize: themeTypographySize.XL, // 40px
      fontWeight: systemTypographyWeight.Bold,
      lineHeight: systemTypographyLineHeight[3]
      // [`@media (max-width: ${systemSpacingUnits.tabletLarge})`]: {
      //   fontSize: systemTypographySize[13] // 36px // adjusted size for screens smaller than 1280px
      // },
      // [`@media (max-width: ${systemSpacingUnits.tablet})`]: {
      //   fontSize: systemTypographySize[12] // 32px // adjusted size for screens smaller than 960px
      // },
      // [`@media (max-width: ${systemSpacingUnits.mobileLarge})`]: {
      //   fontSize: systemTypographySize[11] // 28px // adjusted size for screens smaller than 600px
      // }
    },
    h3: {
      fontSize: themeTypographySize.L, // 36px
      fontWeight: systemTypographyWeight.Bold,
      lineHeight: systemTypographyLineHeight[3]
      // [`@media (max-width: ${systemSpacingUnits.tabletLarge})`]: {
      //   fontSize: systemTypographySize[12] // 32px // adjusted size for screens smaller than 1280px
      // },
      // [`@media (max-width: ${systemSpacingUnits.tablet})`]: {
      //   fontSize: systemTypographySize[11] // 28px // adjusted size for screens smaller than 960px
      // },
      // [`@media (max-width: ${systemSpacingUnits.mobileLarge})`]: {
      //   fontSize: systemTypographySize[10] // 24px // adjusted size for screens smaller than 600px
      // }
    },
    h4: {
      fontSize: themeTypographySize.M, // 32px
      fontWeight: systemTypographyWeight.Bold,
      lineHeight: systemTypographyLineHeight[3]
      // [`@media (max-width: ${systemSpacingUnits.tabletLarge})`]: {
      //   fontSize: systemTypographySize[11] // 28px // adjusted size for screens smaller than 1280px
      // },
      // [`@media (max-width: ${systemSpacingUnits.tablet})`]: {
      //   fontSize: systemTypographySize[10] // 24px // adjusted size for screens smaller than 960px
      // },
      // [`@media (max-width: ${systemSpacingUnits.mobileLarge})`]: {
      //   fontSize: systemTypographySize[9] // 22px // adjusted size for screens smaller than 600px
      // }
    },
    h5: {
      fontSize: themeTypographySize.S, // 24px
      fontWeight: systemTypographyWeight.Bold,
      lineHeight: systemTypographyLineHeight[4]
      // [`@media (max-width: ${systemSpacingUnits.tabletLarge})`]: {
      //   fontSize: systemTypographySize[9] // 22px // adjusted size for screens smaller than 1280px
      // },
      // [`@media (max-width: ${systemSpacingUnits.tablet})`]: {
      //   fontSize: systemTypographySize[8] // 20px // adjusted size for screens smaller than 960px
      // },
      // [`@media (max-width: ${systemSpacingUnits.mobileLarge})`]: {
      //   fontSize: systemTypographySize[7] // 18px // adjusted size for screens smaller than 600px
      // }
    },

    h6: {
      fontSize: themeTypographySize.XS, // 16px
      fontWeight: systemTypographyWeight.Bold,
      lineHeight: systemTypographyLineHeight[4]
    },
    subtitle1: {
      fontSize: themeTypographySize.XXS, // 14px
      fontWeight: systemTypographyWeight.Regular,
      lineHeight: systemTypographyLineHeight[4]
    },
    subtitle2: {
      fontSize: themeTypographySize.XXXS, // 12px
      fontWeight: systemTypographyWeight.Medium,
      lineHeight: systemTypographyLineHeight[5]
    },
    subtitle3: {
      fontSize: themeTypographySize.XXXM, // 13px
      fontWeight: systemTypographyWeight.Medium,
      lineHeight: systemTypographyLineHeight[5]
    },
    body1: {
      fontSize: themeTypographySize.XXS, // 14px
      fontWeight: systemTypographyWeight.Regular,
      lineHeight: systemTypographyLineHeight[4]
    },
    body2: {
      fontSize: themeTypographySize.XXXS, // 12px
      fontWeight: systemTypographyWeight.Regular,
      lineHeight: systemTypographyLineHeight[5]
    },
    button: {
      fontSize: themeTypographySize.XXS, // 14px
      fontWeight: systemTypographyWeight.Regular,
      lineHeight: systemTypographyLineHeight[6],
      textTransform: 'none' // mui buttons are caps by default so we turned that off
    },
    caption: {
      fontSize: themeTypographySize.XXXS, // 12px
      fontWeight: systemTypographyWeight.Regular,
      lineHeight: systemTypographyLineHeight[5]
    },
    overline: {
      fontSize: themeTypographySize.XXXS, // 12px
      fontWeight: systemTypographyWeight.Regular,
      lineHeight: systemTypographyLineHeight[10]
    },
    //start custom typography objects
    displayXlarge: {
      fontSize: systemTypographySize[19], // 100px
      fontWeight: systemTypographyWeight.Semibold,
      lineHeight: systemTypographyLineHeight[2],
      fontFamily: systemTypographyFamily.Sans,
      [`@media (max-width: ${systemSpacingUnits.tabletLarge})`]: {
        fontSize: systemTypographySize[18] // 80px // adjusted size for screens smaller than 1280px
      },
      [`@media (max-width: ${systemSpacingUnits.tablet})`]: {
        fontSize: systemTypographySize[17] // 64px // adjusted size for screens smaller than 960px
      },
      [`@media (max-width: ${systemSpacingUnits.mobileLarge})`]: {
        fontSize: systemTypographySize[16] // 56px // adjusted size for screens smaller than 600px
      }
    },
    displayLarge: {
      fontSize: systemTypographySize[16], // 56px
      fontWeight: systemTypographyWeight.Semibold,
      lineHeight: systemTypographyLineHeight[2],
      fontFamily: systemTypographyFamily.Sans
    },
    displayMedium: {
      fontSize: systemTypographySize[14], // 40px
      fontWeight: systemTypographyWeight.Medium,
      lineHeight: systemTypographyLineHeight[3],
      fontFamily: systemTypographyFamily.Sans
    },
    displaySmall: {
      fontSize: systemTypographySize[13], // 36px
      fontWeight: systemTypographyWeight.Medium,
      lineHeight: systemTypographyLineHeight[3],
      fontFamily: systemTypographyFamily.Sans
    },
    headingLarge: {
      fontSize: systemTypographySize[12], // 32px
      fontWeight: systemTypographyWeight.Medium,
      lineHeight: systemTypographyLineHeight[3],
      fontFamily: systemTypographyFamily.Sans
    },
    headingMedium: {
      fontSize: systemTypographySize[11], // 28px
      fontWeight: systemTypographyWeight.Medium,
      lineHeight: systemTypographyLineHeight[3],
      fontFamily: systemTypographyFamily.Sans
    },
    headingSmall: {
      fontSize: systemTypographySize[10], // 24px
      fontWeight: systemTypographyWeight.Medium,
      lineHeight: systemTypographyLineHeight[4],
      fontFamily: systemTypographyFamily.Sans
    },
    titleLarge: {
      fontSize: systemTypographySize[9], // 22px
      fontWeight: systemTypographyWeight.Medium,
      lineHeight: systemTypographyLineHeight[2],
      fontFamily: systemTypographyFamily.Sans
    },
    titleMedium: {
      fontSize: systemTypographySize[7], // 18px
      fontWeight: systemTypographyWeight.Medium,
      lineHeight: systemTypographyLineHeight[3],
      fontFamily: systemTypographyFamily.Sans
    },
    titleSmall: {
      fontSize: systemTypographySize[5], // 16px
      fontWeight: systemTypographyWeight.Medium,
      lineHeight: systemTypographyLineHeight[4],
      fontFamily: systemTypographyFamily.Sans
    },
    subtitleLarge: {
      fontSize: systemTypographySize[7], // 18px
      fontWeight: systemTypographyWeight.Regular,
      lineHeight: systemTypographyLineHeight[3],
      fontFamily: systemTypographyFamily.Sans
    },
    subtitleMedium: {
      fontSize: systemTypographySize[5], // 16px
      fontWeight: systemTypographyWeight.Regular,
      lineHeight: systemTypographyLineHeight[4],
      fontFamily: systemTypographyFamily.Sans
    },
    subtitleSmall: {
      fontSize: systemTypographySize[3], // 14px
      fontWeight: systemTypographyWeight.Regular,
      lineHeight: systemTypographyLineHeight[4],
      fontFamily: systemTypographyFamily.Sans
    },
    bodyLarge: {
      fontSize: systemTypographySize[7], // 18px
      fontWeight: systemTypographyWeight.Regular,
      lineHeight: systemTypographyLineHeight[4],
      fontFamily: systemTypographyFamily.Sans
    },
    bodyMedium: {
      fontSize: systemTypographySize[5], // 16px
      fontWeight: systemTypographyWeight.Regular,
      lineHeight: systemTypographyLineHeight[4],
      fontFamily: systemTypographyFamily.Sans
    },
    bodySmall: {
      fontSize: systemTypographySize[3], // 14px
      fontWeight: systemTypographyWeight.Regular,
      lineHeight: systemTypographyLineHeight[5],
      fontFamily: systemTypographyFamily.Sans
    },
    captionLarge: {
      fontSize: systemTypographySize[3], // 14px
      fontWeight: systemTypographyWeight.Medium,
      lineHeight: systemTypographyLineHeight[5],
      fontFamily: systemTypographyFamily.Sans
    },
    captionMedium: {
      fontSize: systemTypographySize[1], // 12px
      fontWeight: systemTypographyWeight.Medium,
      lineHeight: systemTypographyLineHeight[5],
      fontFamily: systemTypographyFamily.Sans
    },
    captionSmall: {
      fontSize: systemTypographySize[1], // 12px
      fontWeight: systemTypographyWeight.Medium,
      lineHeight: systemTypographyLineHeight[5],
      fontFamily: systemTypographyFamily.Sans
    },
    labelLarge: {
      fontSize: systemTypographySize[3], // 14px
      fontWeight: systemTypographyWeight.Semibold,
      lineHeight: systemTypographyLineHeight[4],
      fontFamily: systemTypographyFamily.Sans
    },
    labelMedium: {
      fontSize: systemTypographySize[1], // 12px
      fontWeight: systemTypographyWeight.Semibold,
      lineHeight: systemTypographyLineHeight[4],
      fontFamily: systemTypographyFamily.Sans
    },
    labelSmall: {
      fontSize: systemTypographySize.Micro, // 10px
      fontWeight: systemTypographyWeight.Semibold,
      lineHeight: systemTypographyLineHeight[4],
      fontFamily: systemTypographyFamily.Sans
    },
    kpiLarge: {
      fontSize: systemTypographySize[12], // 32px
      fontWeight: systemTypographyWeight.Bold,
      lineHeight: systemTypographyLineHeight[2],
      fontFamily: systemTypographyFamily.Sans
    },
    kpiMedium: {
      fontSize: systemTypographySize[8], // 20px
      fontWeight: systemTypographyWeight.Bold,
      lineHeight: systemTypographyLineHeight[2],
      fontFamily: systemTypographyFamily.Sans
    },
    kpiSmall: {
      fontSize: systemTypographySize[5], // 16px
      fontWeight: systemTypographyWeight.Bold,
      lineHeight: systemTypographyLineHeight[3],
      fontFamily: systemTypographyFamily.Sans
    },
    listItemLarge: {
      fontSize: systemTypographySize[5], // 16px
      fontWeight: systemTypographyWeight.Regular,
      lineHeight: systemTypographyLineHeight[4],
      fontFamily: systemTypographyFamily.Sans
    },
    listItemMedium: {
      fontSize: systemTypographySize[3], // 14px
      fontWeight: systemTypographyWeight.Regular,
      lineHeight: systemTypographyLineHeight[5],
      fontFamily: systemTypographyFamily.Sans
    },
    listItemSmall: {
      fontSize: systemTypographySize[1], // 12px
      fontWeight: systemTypographyWeight.Regular,
      lineHeight: systemTypographyLineHeight[6],
      fontFamily: systemTypographyFamily.Sans
    },
    tabTitle: {
      fontSize: systemTypographySize[8], // 20px
      fontWeight: systemTypographyWeight.Regular,
      lineHeight: systemTypographyLineHeight[6],
      fontFamily: systemTypographyFamily.Sans
    }
    //end custom typography objects
  },
  // spacing: 8,
  breakpoints: {
    // default
    // values: {
    //     xs: 0,
    //     sm: 600,
    //     md: 960,
    //     lg: 1280,
    //     xl: 1920,
    // },
    // custom
    // values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1628,
    xxl: 1920
    // },
  },
  zIndex: {
    // appBar: 1200,
    // drawer: 1100,
  },
  transitions: {
    // easing: {
    //     easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    //     easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    //     easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    //     sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
    // },
    // duration: {
    //     shortest: 150,
    //     shorter: 200,
    //     short: 250,
    //     standard: 300,
    //     complex: 375,
    //     enteringScreen: 225,
    //     leavingScreen: 195,
    // },
    // start disable all transitions comment out (don't delete if you don't like it)
    create: () => 'none',
    duration: {
      shortest: 0,
      shorter: 0,
      short: 0,
      standard: 0,
      complex: 0,
      enteringScreen: 0,
      leavingScreen: 0
    },
    easing: {
      easeInOut: 'linear',
      easeOut: 'linear',
      easeIn: 'linear',
      sharp: 'linear'
    }
  },
  shape: {
    borderRadius: 4 // setting border radius to 8 for all components default is 4
  },
  components: {
    // MuiTextField: {
    //     defaultProps: {
    //         variant: 'outlined',
    //     },
    // },
    // start disable all shadows comment out (don't delete if you don't like it)
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // removes all caps from buttons
          letterSpacing: '1.25px',
          fontStyle: 'normal',
          borderRadius: '4px',
          boxShadow: 'none', // disables drop shadows for all button states
          '&:hover': {
            boxShadow: 'none', // ensures the shadow is also disabled on hover
            backgroundColor: themeColor.hpPrimaryDark,
            border: `1px solid ${themeColor.hpPrimaryDark}`
          },
          '&:active': {
            boxShadow: 'none' // ensures the shadow is also disabled on active state
          },
          '&:focus': {
            // ensures the shadow is also disabled on focus
          },
          '&:disabled': {
            backgroundColor: systemColor.pGray600,
            color: themeColor.hpWhite
          }
        }
      },
      variants: [
        {
          props: {variant: 'outlined'},
          style: {
            letterSpacing: '0.5px',
            fontWeight: systemTypographyWeight.Medium,
            '&:hover': {
              backgroundColor: themeColor.hpPrimaryLightest
            }
          }
        },
        {
          props: {variant: 'text'},
          style: {
            letterSpacing: '0.5px',
            fontWeight: systemTypographyWeight.Medium,
            '&:hover': {
              background: themeColor.hpPrimaryLightest,
              border: 'none'
            }
          }
        },
        {
          props: {variant: 'contrastButton'},
          style: {
            backgroundColor: themeColor.hpWhite,
            color: themeColor.hpPrimaryDark,
            '&:hover': {
              backgroundColor: themeColor.hpWhite,
              textDecoration: 'underline',
              border: `1px solid ${themeColor.hpPrimaryDark}`
            }
          }
        },
        {
          props: {variant: 'LeftPanelButton'},
          style: {
            backgroundColor: themeColor.hpWhite,
            color: themeColor.hpPrimaryDark,
            fontSize: themeTypographySize.XXS,
            marginTop: systemSpacingUnits[1],
            lineHeight: systemTypographyLineHeight[1],
            textTransform: 'capitalize',
            textAlign: 'left',
            float: 'left',
            clear: 'left',
            padding: '6px 5px',
            lineBreak: 'loose',
            letterSpacing: '0.4px',
            '&:hover': {
              background: themeColor.hpPrimaryLightest
            }
          }
        },
        {
          props: {variant: 'breadCrumbButton'},
          style: {
            backgroundColor: themeColor.hpWhite,
            color: themeColor.hpPrimary,
            marginLeft: '-8px',
            marginBottom: '14px',
            padding: '0px',
            textTransform: 'capitalize',
            '&:hover': {
              backgroundColor: themeColor.hpWhite
            },
            fontSize: themeTypographySize.XXS
          }
        },
        {
          props: {variant: 'CustomSettings'},
          style: {
            backgroundColor: themeColor.hpWhite,
            color: themeColor.hpPrimary,
            fontSize: themeTypographySize.XXS,
            textDecoration: 'underline',
            '&:hover': {
              backgroundColor: themeColor.hpWhite,
              textDecoration: 'underline',
              border: 'none'
            },
            '&:disabled': {
              backgroundColor: themeColor.hpWhite,
              color: systemColor.pGray600,
              border: 'none'
            }
          }
        }
      ]
    },
    MuiBox: {
      defaultProps: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      variants: [
        {
          props: {variant: 'LoadingBox'},
          style: {
            flexDirection: 'column',
            marginTop: '300px'
          }
        }
      ]
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: themeTypographySize.S,
          '&:hover': {
            cursor: 'pointer'
          }
        }
      },
      variants: [
        {
          props: {variant: 'primaryIcon'},
          style: {
            fontSize: themeTypographySize.XS,
            color: themeColor.hpPrimaryDark
          }
        },

        {
          props: {variant: 'closeIcon'},
          style: {
            fontSize: themeTypographySize.XXXS,
            color: systemColor.pGray900
          }
        },
        {
          props: {variant: 'warningIcon'},
          style: {
            color: themeColor.hpAccentRed,
            pointerEvents: 'none'
          }
        },
        {
          props: {variant: 'popOverCloseIcon'},
          style: {
            fontSize: themeTypographySize.S,
            color: systemColor.pGray900
          }
        },
        {
          props: {variant: 'DeleteIcon'},
          style: {
            fontSize: themeTypographySize.XS,
            color: systemColor.pGray600
          }
        }
      ]
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0
      }
    },
    MuiCard: {
      defaultProps: {
        elevation: 0
      }
    },
    MuiChip: {
      variants: [
        {
          props: {variant: 'variant1'},
          style: {
            borderRadius: '4px',
            color: themeColor.hpAccentBlack,
            background: themeColor.hpBaseLighter,
            fontSize: systemTypographySize[1],
            fontFamily: systemTypographyFamily.Sans,
            marginLeft: '24px',
            height: '22px',
            '&:focus': {border: `1px solid ${themeColor.hpAccentBlack}`}
          }
        }
      ]
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: themeTypographySize.XXS,
          borderBottom: `1px solid ${systemColor.pGray200}`,
          lineHeight: systemTypographyLineHeight[3]
        }
      },
      variants: [
        {
          props: {variant: 'customSettingTableCell'},
          style: {
            fontSize: themeTypographySize.XXS,
            fontWeight: systemTypographyWeight.Regular,
            border: `1px solid ${themeColor.hpBaseLight}`,
            padding: '10px',
            color: themeColor.hpAccentBlack,
            lineHeight: systemTypographyLineHeight[2]
          }
        },
        {
          props: {variant: 'customSettingTableHeader'},
          style: {
            fontSize: themeTypographySize.XXS,
            fontWeight: systemTypographyWeight.Bold,
            padding: '10px',
            color: themeColor.hpAccentBlack,
            backgroundColor: themeColor.hpBaseLighter
          }
        }
      ]
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '& .MuiSvgIcon-root': {
            fontSize: themeTypographySize.S
          },
          '&:hover': {
            backgroundColor: themeColor.hpPrimaryLightest
          },
          '&.Mui-disabled': {
            color: themeColor.hpBase
          }
        }
      }
    },
    MuiDateCalendar: {
      styleOverrides: {
        root: {
          color: themeColor.hpAccentBlack,
          '& .Mui-disabled': {
            color: themeColor.hpBaseDark
          },
          '& .MuiButtonBase-root': {
            '&:hover': {
              backgroundColor: themeColor.hpPrimaryLightest
            }
          }
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-root': {
            borderRadius: '4px',
            height: themeTypographySize.M
          }
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          mb: 2,
          padding: `0px 16px 0px 16px`,
          fontSize: themeTypographySize.XS,
          backgroundColor: themeColor.hpPrimaryLightest,

          '& .MuiSvgIcon-root': {fontSize: themeTypographySize.S}
        }
      },
      variants: [
        {
          props: {variant: 'error'},
          style: {
            backgroundColor: systemColor.pRed50
          }
        },
        {
          props: {variant: 'warning'},
          style: {
            backgroundColor: systemColor.pOrange50,
            '& .MuiSvgIcon-root': {
              color: themeColor.hpAccentOrange
            }
          }
        },
        {
          props: {variant: 'alert'},
          style: {
            padding: `0px 12px 0px 12px`,
            backgroundColor: systemColor.pOrange50,
            '& .MuiAlert-icon': {
              color: themeColor.hpAccentOrange
            },
            '& .MuiAlert-action': {
              color: themeColor.hpBaseDarker
            },
            '& .MuiSvgIcon-root': {
              fontSize: themeTypographySize.S,
              marginTop: '2px'
            }
          }
        }
      ]
    }

    // end disable all shadows comment out (don't delete if you don't like it)
  }
})

export default pTheme
